// @flow
import Primary from './primary';
import Shipa from './shipaMall';
export var PrimaryButton = Primary;
export var ShipaMallButton = Shipa;